import "./App.css";
import Routes from "./routes";
import { AuthProvider } from "./contexts/AuthContext";
import { MoodleProvider } from "./contexts/MoodleContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { MoodleProviderV2 } from "./contexts/moodle";
import { useEffect } from "react";
import { useConfig } from "./contexts/config";
import { NativeSpinner } from "./components/Loader/spinner";

function App() {
  const config = useConfig();

  useEffect(() => {
    if (!config.config) {
      config
        .getConfig()
        .then(console.log)
        .catch((err) => console.log(err));
    }
    // eslint-disable-next-line
  }, []);

  if (!config.config) {
    return <NativeSpinner />;
  }
  return (
    <ThemeProvider>
      <AuthProvider>
        <MoodleProvider>
          <MoodleProviderV2>
            <Routes />
          </MoodleProviderV2>
        </MoodleProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
